import { TileCorner, TileEdge, TileHex } from './Tile.ts';
import { TileHexType } from '@colonist/game-states';
export class TileState {
    get tiles() {
        return this._tiles;
    }
    get tileCorners() {
        return this._tileCorners;
    }
    get tileEdges() {
        return this._tileEdges;
    }
    addNewTile(tile) {
        this._tiles.push(tile);
        const index = this.tiles.length - 1;
        this.tileHexStates[index] = tile.state;
        this.indexTileHex(tile, index);
        return index;
    }
    addNewCorner(tileCorner) {
        this._tileCorners.push(tileCorner);
        const index = this.tileCorners.length - 1;
        this.tileCornerStates[index] = tileCorner.state;
        this.indexMapCorner(tileCorner, index);
    }
    addNewEdge(tileEdge) {
        this._tileEdges.push(tileEdge);
        const index = this.tileEdges.length - 1;
        this.tileEdgeStates[index] = tileEdge.state;
        this.indexMapEdges(tileEdge, index);
    }
    loadMap() {
        this.loadMapTiles();
        this.loadMapCorners();
        this.loadMapEdges();
    }
    loadMapTiles() {
        for(const index in this.tileHexStates){
            const tileState = this.tileHexStates[index];
            if (tileState == undefined) continue;
            const tileHex = new TileHex(tileState);
            this._tiles.push(tileHex);
            const arrayIndex = this.tiles.length - 1;
            this.indexTileHex(tileHex, arrayIndex);
        }
    }
    indexTileHex(tileHex, index) {
        var _this_tileHexIndexes_tileHex_hexFace_x;
        const xIndexLayer = (_this_tileHexIndexes_tileHex_hexFace_x = this.tileHexIndexes[tileHex.hexFace.x]) !== null && _this_tileHexIndexes_tileHex_hexFace_x !== void 0 ? _this_tileHexIndexes_tileHex_hexFace_x : [];
        xIndexLayer[tileHex.hexFace.y] = index;
        this.tileHexIndexes[tileHex.hexFace.x] = xIndexLayer;
    }
    loadMapCorners() {
        for(const index in this.tileCornerStates){
            const tileCornerState = this.tileCornerStates[index];
            if (tileCornerState == undefined) continue;
            const tileCorner = new TileCorner(tileCornerState);
            this._tileCorners.push(tileCorner);
            const arrayIndex = this.tileCorners.length - 1;
            this.indexMapCorner(tileCorner, arrayIndex);
        }
    }
    indexMapCorner(tileCorner, index) {
        var _this_tileCornerIndexes_tileCorner_hexCorner_x;
        const xIndexLayer = (_this_tileCornerIndexes_tileCorner_hexCorner_x = this.tileCornerIndexes[tileCorner.hexCorner.x]) !== null && _this_tileCornerIndexes_tileCorner_hexCorner_x !== void 0 ? _this_tileCornerIndexes_tileCorner_hexCorner_x : [];
        var _xIndexLayer_tileCorner_hexCorner_y;
        const yIndexLayer = (_xIndexLayer_tileCorner_hexCorner_y = xIndexLayer[tileCorner.hexCorner.y]) !== null && _xIndexLayer_tileCorner_hexCorner_y !== void 0 ? _xIndexLayer_tileCorner_hexCorner_y : [];
        yIndexLayer[tileCorner.hexCorner.z] = index;
        xIndexLayer[tileCorner.hexCorner.y] = yIndexLayer;
        this.tileCornerIndexes[tileCorner.hexCorner.x] = xIndexLayer;
    }
    loadMapEdges() {
        for(const index in this.tileEdgeStates){
            const tileEdgeState = this.tileEdgeStates[index];
            if (tileEdgeState == undefined) continue;
            const tileEdge = new TileEdge(tileEdgeState);
            this._tileEdges.push(tileEdge);
            const arrayIndex = this.tileEdges.length - 1;
            this.indexMapEdges(tileEdge, arrayIndex);
        }
    }
    indexMapEdges(tileEdge, index) {
        var _this_tileEdgeIndexes_tileEdge_hexEdge_x;
        const xIndexLayer = (_this_tileEdgeIndexes_tileEdge_hexEdge_x = this.tileEdgeIndexes[tileEdge.hexEdge.x]) !== null && _this_tileEdgeIndexes_tileEdge_hexEdge_x !== void 0 ? _this_tileEdgeIndexes_tileEdge_hexEdge_x : [];
        var _xIndexLayer_tileEdge_hexEdge_y;
        const yIndexLayer = (_xIndexLayer_tileEdge_hexEdge_y = xIndexLayer[tileEdge.hexEdge.y]) !== null && _xIndexLayer_tileEdge_hexEdge_y !== void 0 ? _xIndexLayer_tileEdge_hexEdge_y : [];
        yIndexLayer[tileEdge.hexEdge.z] = index;
        xIndexLayer[tileEdge.hexEdge.y] = yIndexLayer;
        this.tileEdgeIndexes[tileEdge.hexEdge.x] = xIndexLayer;
    }
    // ====================================================================================================================================
    // Getters: Tile index
    // ====================================================================================================================================
    getTileHexIndex(hexFace) {
        const xIndexLayer = this.tileHexIndexes[hexFace.x];
        if (xIndexLayer == undefined) return undefined;
        return xIndexLayer[hexFace.y];
    }
    getTileCornerIndex(hexCorner) {
        const xIndexLayer = this.tileCornerIndexes[hexCorner.x];
        if (xIndexLayer == undefined) return undefined;
        const yIndexLayer = xIndexLayer[hexCorner.y];
        if (yIndexLayer == undefined) return undefined;
        return yIndexLayer[hexCorner.z];
    }
    getTileEdgeIndex(hexEdge) {
        const xIndexLayer = this.tileEdgeIndexes[hexEdge.x];
        if (xIndexLayer == undefined) return undefined;
        const yIndexLayer = xIndexLayer[hexEdge.y];
        if (yIndexLayer == undefined) return undefined;
        return yIndexLayer[hexEdge.z];
    }
    // ====================================================================================================================================
    // Getters: Tile parts
    // ====================================================================================================================================
    getTileHex(hexFace) {
        const tileHexIndex = this.getTileHexIndex(hexFace);
        if (tileHexIndex == undefined) return undefined;
        const tileHex = this.tiles[tileHexIndex];
        if (tileHex == undefined) return undefined;
        if (!tileHex.hexFace.sameFace(hexFace)) return undefined;
        return tileHex;
    }
    getTileCorner(hexCorner) {
        const tileCornerIndex = this.getTileCornerIndex(hexCorner);
        if (tileCornerIndex == undefined) return undefined;
        const tileCorner = this.tileCorners[tileCornerIndex];
        if (tileCorner == undefined) return undefined;
        if (!tileCorner.hexCorner.sameCorner(hexCorner)) return undefined;
        return tileCorner;
    }
    getTileEdge(hexEdge) {
        const tileEdgeIndex = this.getTileEdgeIndex(hexEdge);
        if (tileEdgeIndex == undefined) return undefined;
        const tileEdge = this.tileEdges[tileEdgeIndex];
        if (tileEdge == undefined) return undefined;
        if (!tileEdge.hexEdge.sameEdge(hexEdge)) return undefined;
        return tileEdge;
    }
    // ====================================================================================================================================
    // Are parts touching land
    // ====================================================================================================================================
    isEdgeTouchingLand(tileEdge) {
        for (const touchingFace of tileEdge.hexEdge.touchingFaces()){
            const touchingTile = this.getTileHex(touchingFace);
            if (touchingTile == undefined) continue;
            if (touchingTile.isTileLand()) return true;
        }
        return false;
    }
    isCornerTouchingLand(tileCorner) {
        for (const touchingFace of tileCorner.hexCorner.touchingFaces()){
            const touchingTile = this.getTileHex(touchingFace);
            if (touchingTile == undefined) continue;
            if (touchingTile.isTileLand()) return true;
        }
        return false;
    }
    // ====================================================================================================================================
    // Are parts touching sea
    // ====================================================================================================================================
    isEdgeTouchingSea(tileEdge) {
        for (const touchingFace of tileEdge.hexEdge.touchingFaces()){
            const touchingTile = this.getTileHex(touchingFace);
            if (touchingTile == undefined) return true;
            if (touchingTile.tileType == TileHexType.Sea) return true;
        }
        return false;
    }
    isCornerTouchingSea(tileCorner) {
        for (const touchingFace of tileCorner.hexCorner.touchingFaces()){
            const touchingTile = this.getTileHex(touchingFace);
            if (touchingTile == undefined) return true;
            if (touchingTile.tileType == TileHexType.Sea) return true;
        }
        return false;
    }
    // ====================================================================================================================================
    // Are parts on shore
    // ====================================================================================================================================
    isEdgeOnShore(hexEdge) {
        const tileEdge = this.getTileEdge(hexEdge);
        if (tileEdge == undefined) return false;
        if (!this.isEdgeTouchingLand(tileEdge)) return false;
        if (!this.isEdgeTouchingSea(tileEdge)) return false;
        return true;
    }
    isCornerOnShore(hexCorner) {
        const tileCorner = this.getTileCorner(hexCorner);
        if (tileCorner == undefined) return false;
        if (!this.isCornerTouchingLand(tileCorner)) return false;
        if (!this.isCornerTouchingSea(tileCorner)) return false;
        return true;
    }
    isTileOnShore(tileHex) {
        if (!tileHex.isTileLand()) return false;
        for (const neightbor of tileHex.hexFace.neighbors()){
            const neighboringTile = this.getTileHex(neightbor);
            if (neighboringTile == undefined) return true;
            if (neighboringTile.tileType == TileHexType.Sea) return true;
        }
        return false;
    }
    // ====================================================================================================================================
    // Tile pieces
    // ====================================================================================================================================
    getPlacedEdgePieceCountForPlayer(edgePieceType, player) {
        let count = 0;
        for(const tileEdgeStateKey in this.tileEdgeStates){
            const tileEdgeState = this.tileEdgeStates[tileEdgeStateKey];
            if (tileEdgeState == undefined) continue;
            if (tileEdgeState.type != edgePieceType) continue;
            if (tileEdgeState.owner != player) continue;
            count += 1;
        }
        return count;
    }
    getPlacedCornerBuildingCountForPlayer(cornerBuildingType, player) {
        let count = 0;
        for(const tileCornerStateKey in this.tileCornerStates){
            const tileCornerState = this.tileCornerStates[tileCornerStateKey];
            if (tileCornerState == undefined) continue;
            if (tileCornerState.buildingType != cornerBuildingType) continue;
            if (tileCornerState.owner != player) continue;
            count += 1;
        }
        return count;
    }
    constructor(tileHexStates, tileCornerStates, tileEdgeStates){
        this._tiles = [];
        this._tileCorners = [];
        this._tileEdges = [];
        this.tileHexStates = tileHexStates;
        this.tileCornerStates = tileCornerStates;
        this.tileEdgeStates = tileEdgeStates;
        this.tileHexIndexes = [];
        this.tileCornerIndexes = [];
        this.tileEdgeIndexes = [];
        this.loadMap();
    }
}
